import { Injectable } from '@angular/core';
import { BOBCAT_API, KONTRACTOR_API } from '../../common/utils/api.bobcat';
import { HttpService } from '../../common/utils/http.service';
import { User } from '../../models/user';
import { Router } from '@angular/router';
import { StateService } from '../state/state.service';
import store from '../state/state.service';
import { Observable } from 'rxjs/Observable';
import IAction, { Actions } from '../state/actions';

const new_user: IAction = {
  type: Actions.ADD_USER
}

@Injectable()
export class LoginService {

  user: User;
  isLogged: boolean = false;


  constructor(
    private httpservice: HttpService,
    private router: Router,
    private state: StateService
  ) {
  }

  /*getUser(pwd: string, email: string) {
    let params = {
      'pwd': pwd.toString(),
      'email': email.toString()
    }
    this.httpservice.post(BOBCAT_API.LOGIN, params).subscribe((user: any) => {
      this.user = user.user;
      if (this.user) {
        this.isLogged = true;
      }
      this.createUser(this.user);
      localStorage.setItem('currentuser', JSON.stringify(this.user));
      new_user.payload = this.user
      store.dispatch(new_user);
      this.router.navigate(['choicedocument']);
    }
    );
  }*/



  //new
  auth(data) {
    return this.httpservice.post(KONTRACTOR_API.login, data, true).map((result: { auth: boolean }) => {
      if (result.auth) {
        this.httpservice.setSession();
        this.setUser(data);
        this.redirectAfterLogin();



      }
      return result.auth;
    })
  }
  verif() {
    if (this.httpservice.verifTimeout()) {
      this.redirectAfterLogin();
    }
    return this.httpservice.verifTimeout();
  }
  redirectAfterLogin() {
    let user = this.getUser();
    if (user && "type_doc" in user) {
      let typeDocUser = user.type_doc;
      if (typeDocUser.indexOf(":") != -1) {
        let type = typeDocUser.split(":");
        this.router.navigate(['/steps', type[0], type[1]]);
      }
      else {
        this.router.navigate(['choicedocument']);
      }
    }
    else {
      this.router.navigate(['choicedocument']);
    }
  }

  setUser(data) {
    localStorage.setItem('konTractorUser', JSON.stringify(data));
  }

  getUser() {
    let user = localStorage.getItem('konTractorUser');
    if (user) {
      return JSON.parse(user);
    }
    else {
      return null;
    }
  }




}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/login/login.service.ts